import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { colors, Loader } from "swyft-react-core";
import { Box, makeStyles, Container, Grid } from "@material-ui/core";

import { CustomerSay, QuoteBox } from "./components";
import { CookieQuoteId } from "../../app/consts";
import { RootState } from "../../app/rootReducer";
import { fetchRelatedQuotes } from "../../store/QuotesSlice";
import { Header } from "../quoteDetailPage/components/Header";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { fontFamily } from "../../app/theme";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: fontFamily.Axiforma
  },
  alternate: {
    background: colors.alternate
  },
  boxList: {
    paddingBottom: theme.spacing(3)
  }
}));

export const MyQuotesPage: React.FC = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [cookies] = useCookies();
  const { isMoreThanSm } = useBreakpoint();

  const { isLoading, error, relatedQuotes } = useSelector((state: RootState) => state.quotes);

  const cookieQuoteId = cookies[CookieQuoteId];

  const { quote } = useSelector((state: RootState) => state.quote);

  useEffect(() => {
    if (relatedQuotes && relatedQuotes.length > 0) {
      return;
    }
    if (cookieQuoteId) {
      dispatch(fetchRelatedQuotes(cookieQuoteId));
    }
  }, [dispatch, cookieQuoteId, quote, relatedQuotes]);

  if (!cookieQuoteId || !relatedQuotes || isLoading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error</div>;
  }

  return (
    <Box className={classes.root}>
      <Container maxWidth="lg">
        <Header />
        <Box textAlign="center" mt={3} mb={6}>
          <Box fontSize={isMoreThanSm ? "28px" : "20px"} fontWeight={500} color="#1e073f" textAlign={"center"}>
            My Swyft Quotes
          </Box>
          <Box
            fontSize={isMoreThanSm ? "16px" : "14px"}
            textAlign="center"
            mt={1}
            fontWeight={400}
            color={isMoreThanSm ? "#4b5462" : "rgba(17, 21, 33, 0.65)"}
          >
            Here are your quotes. You can view the details of each quote by clicking on view quote.
          </Box>
        </Box>

        <Grid container spacing={3} className={classes.boxList}>
          {relatedQuotes.map((q) => (
            <Grid key={q.id} item xs={12} md={6}>
              <QuoteBox quote={q} />
            </Grid>
          ))}
        </Grid>
      </Container>

      <Box mb={6} mt={3}>
        <CustomerSay />
      </Box>
    </Box>
  );
};
